import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';

// Helper to get initial theme from localStorage
const getInitialTheme = () => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('theme');
    return saved === 'dark';
  }
  return false;
};

const ThemeToggle = ({ className = '' }) => {
  const [isDark, setIsDark] = useState(getInitialTheme);

  // Use useLayoutEffect to apply theme before paint to avoid flash
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setIsDark(!isDark)}
      className={`w-9 h-9 p-0 ${className}`}
      data-testid="theme-toggle"
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      {isDark ? (
        <Sun className="w-5 h-5 text-amber-500" />
      ) : (
        <Moon className="w-5 h-5 text-slate-600" />
      )}
    </Button>
  );
};

export default ThemeToggle;
